<template>
  <swiper :ref="theDamnRef" :options="swiperOptions">
    <swiper-slide v-for="item in media" :style="`background: url(${item.url})`" :key="item.id"></swiper-slide>
    <div class="swiper-pagination" slot="pagination"></div>
  </swiper>
</template>

<script>
  import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
  import 'swiper/css/swiper.css'
  export default {
    props:['media', 'id'],

    components: {
        Swiper,
        SwiperSlide,
    },

    directives: {
        swiper: directive
    },

    name: 'carrousel',
    data() {
      return {
        swiperOptions: {
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
          },
        }
      }
    },
    computed: {
      theDamnRef () {
        return 'mySwiper-' + this.id
      },

      swiper() {
        return this.$refs[this.theDamnRef].$swiper
      }
    },
    mounted() {
      // console.log('Current Swiper instance object', this.swiper)
      // this.swiper.slideTo(3, 1000, false)
    }
  }
</script>
